import { useGetUpcomingPaymentsQuery } from "@/services/dashboard";

const useUpcomingPayments = () => {
  const { data, error, isLoading } = useGetUpcomingPaymentsQuery();

  return {
    upcomingPayments: data?.data?.items || [],
    isLoading,
    error,
  };
};

export default useUpcomingPayments;